import { PageFade } from "../components/site/Motion";
import { PageHeader, Pillars, WhyStruktiv, Parcours } from "../components/site/Sections";
import { ConsultationSection } from "../components/site/ConsultationSection";

export default function Pourquoi() {
  return (
    <PageFade>
      <PageHeader eyebrow="Structurer • Protéger • Propulser" title="Une finance plus simple," accent="plus humaine." image="/img/entrepreneur1.jpg">
        <p className="max-w-xl text-lg text-[#242020]/80">STRUKTIV accompagne les professionnels d'ici avec une approche accessible, sans jargon et sans pression.</p>
      </PageHeader>
      <WhyStruktiv />
      <Pillars />
      <Parcours />
      <ConsultationSection />
    </PageFade>
  );
}
